// A small in-memory event log, used to diagnose the music player. It is always
// recording (cheap) and shown on the page only in debug mode (?debug).

const MAX_ENTRIES = 400;
let entries = [];
const listeners = new Set();

// keep only JSON-safe data so a report can always be written
function safe(data) {
  if (data === undefined) return undefined;
  try {
    return JSON.parse(JSON.stringify(data, (key, value) => (value instanceof Error ? { name: value.name, message: value.message } : value)));
  } catch (error) {
    return String(data);
  }
}

export function logEvent(source, event, data) {
  entries.push({
    t: Math.round(performance.now()),
    at: new Date().toISOString(),
    source,
    event,
    data: safe(data)
  });
  if (entries.length > MAX_ENTRIES) entries = entries.slice(-MAX_ENTRIES);
  listeners.forEach((listener) => listener());
}

export const getLog = () => entries.slice();

export function clearLog() {
  entries = [];
  listeners.forEach((listener) => listener());
}

export function subscribe(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export const isDebugMode = () => {
  try {
    return new URLSearchParams(window.location.search).has('debug');
  } catch (error) {
    return false;
  }
};

let captureInstalled = false;

// Record uncaught errors and blocked requests too, since they are often the clue
export function installGlobalCapture() {
  if (captureInstalled || typeof window === 'undefined') return;
  captureInstalled = true;
  window.addEventListener('error', (event) => {
    logEvent('window', 'error', { message: event.message, source: event.filename, line: event.lineno });
  });
  window.addEventListener('unhandledrejection', (event) => {
    logEvent('window', 'unhandledrejection', { reason: String(event.reason && event.reason.message ? event.reason.message : event.reason) });
  });
  document.addEventListener('securitypolicyviolation', (event) => {
    logEvent('window', 'securitypolicyviolation', { blocked: event.blockedURI, directive: event.violatedDirective });
  });
}
